import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

const Aboutus = () => (
  <StaticQuery
    query={graphql`
  query {
    imageSharp(fixed: {originalName: {eq: "paladion-video.jpg"}}){
      fixed(width: 540, height: 315) {
        ...GatsbyImageSharpFixed
      }
    }
  }
`}
    render={data => (
      <div id="about" className="space-medium split-bg testimonial-block-v1">
        <div className="container">
          <div className="row">
            {/* testimonial block start */}
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 m-b-10">
              <h2 className="text-white">About Us</h2>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
              {/* testimonial block img */}
              <div className="testimonial-img shadow card-pattern-right">
                <div className="video-container">
                  <Img fixed={data.imageSharp.fixed} alt="paladion video" className="img-fluid" />
                  <a href="https://www.youtube.com/watch?v=pvYLX7_Wk2M">{' '}</a>
                </div>

              </div>
            </div>
            <div className="offset-xl-1 col-xl-5  col-lg-6 col-md-6 col-sm-12 col-12">
              {/* testimonial block start */}
              <div className="testimonial-block">
                {/* testimonial block content */}
                <div className="testimonial-meta-text">
                  <span className="testimonial-meta-name">
                  Over a Decade of Experience in Cyber Security
                  </span>
                </div>
                <div className="testimonial-content">

                  <p className="testimonail-text">
            “ Paladion is a robust managed security service provider, with over a decade of experience, trusted by organizations from around the globe from Asia to the US to EMEA. Currently, we are actively servicing more than 700 satisfied clients while continuing to truly transform customer experience, with IT security as our top priority.
                  </p>
                  <p className="testimonail-text">
            Paladion assists its Partners to improve their business operations by leveraging its industry-wide experience, expertise in cutting-edge technology and an extensive portfolio of services.”
                  </p>
                  {/* testimonial meta */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
  />
);

export default Aboutus;
